import { render, staticRenderFns } from "./QuestionWrapper.vue?vue&type=template&id=1e697f5c&scoped=true&"
import script from "./QuestionWrapper.vue?vue&type=script&lang=ts&"
export * from "./QuestionWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e697f5c",
  null
  
)

export default component.exports